// keyboard keycode
export var Enter = {
    key: 'Enter',
    code: 13,
};
export var Esc = {
    key: 'Escape',
    code: 27,
};
export var Backspace = {
    key: 'Backspace',
    code: 8,
};
export var Tab = {
    key: 'Tab',
    code: 9,
};
export var Space = {
    key: '',
    code: 32,
};
export var ArrowUp = {
    key: 'ArrowUp',
    code: 38,
};
export var ArrowDown = {
    key: 'ArrowDown',
    code: 40,
};
export var ArrowLeft = {
    key: 'ArrowLeft',
    code: 37,
};
export var ArrowRight = {
    key: 'ArrowRight',
    code: 39,
};
